"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }






var _protocol = require('./protocol');
var _uploadDirect = require('./uploadDirect');

// The minimal XMLHttpRequest surface the transport uses, so tests can fake it.













 class BrowserUploadFailedError extends Error {
   __init() {this.retryable = true}
  constructor (message) {
    super(message);BrowserUploadFailedError.prototype.__init.call(this);
    this.name = 'BrowserUploadFailedError'
  }
} exports.BrowserUploadFailedError = BrowserUploadFailedError;

const abortError = () => {
  const error = new Error('Upload aborted')
  error.name = 'AbortError'
  return error
}

















// Uploads a Blob/File to a GCS resumable session from the browser in chunks
// (foreground only; a reload drops it and the server expires the session).
// A dropped connection resumes from what GCS has persisted.
 const createBrowserTransport = (file, {
  createRequest = () => new XMLHttpRequest() ,
  maxAttempts = 5,
  wait = ms => new Promise(resolve => setTimeout(resolve, ms)),
  origin = _optionalChain([globalThis, 'access', _ => _.location, 'optionalAccess', _2 => _2.origin]),
} = {}) => {
  const cancelled = new Set()
  const current = new Map()

  const request = (uploadKey, url, contentRange, body, onProgress) =>
    new Promise((resolve, reject) => {
      const xhr = createRequest()
      current.set(uploadKey, xhr)
      xhr.open('PUT', url)
      xhr.setRequestHeader('Content-Range', contentRange)
      if (onProgress) xhr.upload.onprogress = event => onProgress(event.loaded)
      xhr.onload = () => {
        current.delete(uploadKey)
        // Only a 308 carries (and exposes) Range; asking a readable final 200
        // for it logs "Refused to get unsafe header".
        resolve({ status: xhr.status, range: xhr.status === 308 ? xhr.getResponseHeader('Range') : null })
      }
      xhr.onerror = () => {
        current.delete(uploadKey)
        resolve({ status: 0, range: null })
      }
      xhr.onabort = () => {
        current.delete(uploadKey)
        reject(abortError())
      }
      xhr.send(body)
    })

  return {
    upload: async (started, onProgress) => {
      const key = started.UploadKey
      const total = file.size
      let offset = 0
      let attempts = 0
      // The server opened the session for this page, so GCS's answers to the
      // final chunk and to status queries are readable: an unreadable one is
      // a real failure. Without it (a server that predates SessionOrigin, or
      // another origin) the final answer is never readable.
      const finalReadable = !!origin && started.SessionOrigin === origin
      const check = () => {
        if (cancelled.has(key)) throw abortError()
      }

      while (true) {
        check()
        const chunk = _protocol.nextChunk.call(void 0, offset, started.ChunkBytes, total)
        if (!chunk) {
          onProgress(total, total)
          return
        }
        let sentAll = false
        const response = await request(key, started.SessionURI, _protocol.contentRangeForChunk.call(void 0, chunk.start, chunk.end, total),
          file.slice(chunk.start, chunk.end + 1), loaded => {
            sentAll = loaded >= chunk.length
            onProgress(chunk.start + loaded, total)
          })
        let outcome = _protocol.classifySessionResponse.call(void 0, response.status)
        let range = response.range

        if (outcome === 'retry') {
          // Fallback for a session not opened for this page: GCS's answer to
          // the final chunk then carries no CORS headers, so the browser
          // can't read it. An unreadable answer after the whole last chunk
          // went out is most likely that: check at once, and if the status
          // query is unreadable too, let CompleteUpload confirm on the server
          // (and a Retry upload again if it says the upload isn't finished).
          const maybeBlockedFinish = !finalReadable && response.status === 0 && sentAll && chunk.end === total - 1
          check()
          if (!maybeBlockedFinish) await wait(_protocol.retryDelayMs.call(void 0, attempts))
          check()
          const status = await request(key, started.SessionURI, _protocol.contentRangeForStatusQuery.call(void 0, total), null)
          if (maybeBlockedFinish && status.status === 0) {
            onProgress(total, total)
            return
          }
          outcome = _protocol.classifySessionResponse.call(void 0, status.status)
          range = status.range
        }

        switch (outcome) {
          case 'complete':
            onProgress(total, total)
            return
          case 'restart':
            throw new (0, _uploadDirect.SessionRestartError)()
          case 'incomplete': {
            const persisted = _protocol.nextOffsetFromRange.call(void 0, range)
            attempts = persisted > offset ? 0 : attempts + 1
            offset = persisted
            break
          }
          case 'retry':
            attempts++
            break
        }
        if (attempts >= maxAttempts) throw new BrowserUploadFailedError('Upload stopped making progress')
      }
    },
    cancel: async (uploadKey) => {
      cancelled.add(uploadKey)
      _optionalChain([current, 'access', _3 => _3.get, 'call', _4 => _4(uploadKey), 'optionalAccess', _5 => _5.abort, 'call', _6 => _6()])
    },
  }
}; exports.createBrowserTransport = createBrowserTransport
